<div class="p-8 rounded-md w-full">
  <div class="mb-8">
    <h1 class="text-2xl font-bold mb-3">
      {{ 'setting-confirmation-modal.title' | translate }}
    </h1>
    <p class="opacity-70">
      {{ 'setting-confirmation-modal.description' | translate }}
    </p>
    <br />
    <p class="opacity-70">
      {{ 'setting-confirmation-modal.link-description' | translate }}
      <a
        [href]="'setting-confirmation-modal.link' | translate"
        target="_blank"
        class="text-brand underline"
        >{{ 'setting-confirmation-modal.documentation' | translate }}</a
      >
    </p>
  </div>
  <div class="flex justify-between button-group-container">
    <rk-button
      [text]="'setting-confirmation-modal.save' | translate"
      [variant]="'border-grey'"
      (buttonClick)="onSaveSettings()"
    ></rk-button>
    <div class="flex gap-4">
      <rk-button
        [text]="'setting-confirmation-modal.cancel' | translate"
        [variant]="'secondary'"
        (buttonClick)="onCancel()"
      ></rk-button>
      <rk-button
        [text]="'setting-confirmation-modal.save-redirect' | translate"
        (buttonClick)="onSaveSettingsAndRedirect()"
      ></rk-button>
    </div>
  </div>
</div>
